import * as React from 'react'
import { useState } from 'react'
import { useTranslate } from 'react-admin'
import { useMutation } from 'react-query'
import { makeStyles } from '@material-ui/core'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
import useFormValidation from '../../../hooks/useFormValidation'
import resetPasswordFormStyles from './resetPasswordForm.styles'
import ButtonWithLoader from '../../../components/ui/ButtonWithLoader/ButtonWithLoader'
import MyTextFieldPassword from '../../../components/form/fields/MyTextFieldPassword'
import MySnackbar from '../../../components/MySnackbar/MySnackbar'
import useHistoryPush from '../../../hooks/useHistoryPush'
import resetPassword from '../../../Apis/user/resetPassword'
import getQueryParameterByName from '../../../utils/helpers/getQueryParameterByName'

// AuthService.ResetPassword puts the Identity failure in the 400 body's `details` as
// "Failed to reset password: <Code>: <Description>". Match the code — it is stable, unlike the
// English description — so the user gets localized copy instead of the raw backend string.
const ERROR_CODE_KEYS = {
  InvalidToken: 'ra.errorMessages.resetPasswordLinkExpired',
  PasswordBreached: 'ra.errorMessages.passwordBreached',
  PasswordTooShort: 'ra.validationErrors.password',
}

const ResetPasswordForm = () => {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const translate = useTranslate()
  const { password } = useFormValidation()
  const { redirect } = useHistoryPush()
  const email = getQueryParameterByName('email')
  const resetPasswordToken = getQueryParameterByName('resetPasswordToken')
  const useStyles = makeStyles(resetPasswordFormStyles)
  const classes = useStyles()

  const resetThePassword = useMutation((data) => resetPassword(data), {
    onSuccess: () => {
      redirect('/login', [{ email }])
    },
    onError: (error) => {
      const data = error?.response?.data
      const details = data?.details || data?.message || ''
      const code = Object.keys(ERROR_CODE_KEYS).find((errorCode) => details.includes(errorCode))
      setErrorMessage(
        code
          ? translate(ERROR_CODE_KEYS[code])
          : details || translate('ra.errorMessages.resetPasswordError'),
      )
      setIsSnackbarOpen(true)
    },
  })

  const onCloseSnackbar = () => setIsSnackbarOpen(false)

  const onSubmit = (data) => {
    resetThePassword.mutate({
      ...data,
      email,
      resetPasswordToken,
    })
  }

  return (
    <Formik
      initialValues={{
        password: '',
      }}
      validationSchema={yup.object().shape({
        password,
      })}
      onSubmit={(data) => onSubmit(data)}
    >
      {() => (
        <Form>
          <div className={classes.formWrapper}>
            <MyTextFieldPassword
              label={translate('ra.formFields.password')}
              name='password'
              required
            />
            <ButtonWithLoader
              fullWidth
              label={translate('ra.buttons.submit')}
              style={{ marginTop: 10 }}
              loading={resetThePassword.isLoading}
            />
          </div>
          <MySnackbar
            isOpen={isSnackbarOpen}
            onClose={onCloseSnackbar}
            errorMessage={errorMessage}
          />
        </Form>
      )}
    </Formik>
  )
}

export default ResetPasswordForm
